import { NgModule } from '@angular/core';

import { MasterPerfilUsuarioActions } from './master-perfil-usuario.actions';
import { AnteriorAction } from './master-anterior-perfil-usuario.action';
import { ProximoAction } from './master-proximo-perfil-usuario.action';

@NgModule({
  providers: [
      AnteriorAction,
      ProximoAction,
    MasterPerfilUsuarioActions
  ]
})
export class MasterPerfilUsuarioActionsModule {}
